/* unplugin-vue-components disabled */import { render } from "./weinan.vue?vue&type=template&id=afea04e4&scoped=true"
import script from "./weinan.vue?vue&type=script&lang=js"
export * from "./weinan.vue?vue&type=script&lang=js"

import "./weinan.vue?vue&type=style&index=0&id=afea04e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afea04e4"]])

export default __exports__